<template lang="pug">
.container-restricao.row
    .col-8
        small Foram detectadas sobreposições com as seguintes áreas embargadas pela Sema - MT:

        .list-group
            a.list-group-item.list-group-item-action
                .row
                    label.col-3 Nome
                    label.col-3 Área (ha)
                    label.col-5 Dano

            a.list-group-item.list-group-item-action(
                v-for='(restricao, index) in areaEmbargada.restricoes'
            )
                .row
                    .col-3
                        span(
                            data-toggle='tooltip',
                            data-placement='bottom',
                            data-boundary='body'
                        ) {{ restricao.properties.nome }} - {{ restricao.properties.cpf_cnpj }}

                    .col-3
                        span {{ getArea(restricao) }}

                    .col-5
                        span(
                            data-toggle='tooltip',
                            data-placement='bottom',
                            data-boundary='body'
                        ) {{ restricao.properties.dano }}

    .col-4
        mapa(
            v-if='layersMaps',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :locked='true',
            :height='"180px"',
            :idMapa='"mapaRestricaoAreaEmbargadaSemaMT"'
        )
</template>

<script>
import Mapa from '@/components/MapaLeaflet';

import LayerStyle from '@/utils/layerStyles';
import formatters from '@/utils/formatters';

export default {
    name: 'AreaEmbargadaSemaMT',

    components: {
        Mapa
    },

    data() {
        return {
            layersMaps: null,
            mapConfig: {
                controls: {
                    fullscreen: true
                }
            }
        };
    },
    props: {
        areaEmbargada: {
            type: Object,
            required: true
        },

        geometriaAreaMonitorada: {
            type: Object,
            required: true
        }
    },
    methods: {
        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: 'Área Monitorada',
                geoJson: this.geometriaAreaMonitorada
            };

            this.layersMaps.push(layerAreaMonitorada);

            this.areaEmbargada.restricoes.forEach(feature => {
                let layerRestricao = {
                    style: LayerStyle.RESTRICAO(),
                    geoJson: feature.geometry,
                    name: 'Áreas embargadas - Sema MT',
                    tooltip: `Nome: ${feature.properties.nome} - ${feature.properties.cpf_cnpj}`
                };

                this.layersMaps.push(layerRestricao);
            });
        },

        getArea(restricao) {
            return formatters.formatNumber(
                restricao.properties.areaTotalFeatureHa,
                2
            );
        }
    },
    mounted() {
        this.configureLayersMapa();
    }
};
</script>
